import { render } from "./KakaoPreview.vue?vue&type=template&id=4c372172&scoped=true"
import script from "./KakaoPreview.vue?vue&type=script&lang=js"
export * from "./KakaoPreview.vue?vue&type=script&lang=js"

import "./KakaoPreview.vue?vue&type=style&index=0&id=4c372172&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c372172"]])

export default __exports__